import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';

export default function CourseCard({onCourseClick, course}) {

    const slugify = (str) => {
        return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
    }

    const handleClick = () => {
        onCourseClick(course)
    }

    return (
        <Card 
        data-cy={`course-card-${slugify(course.name)}`}
        sx={{
            width: '90%',
            maxWidth: '213px',
            height: '85px',
            marginTop: '10px',
            borderTopRightRadius: '35px',
            borderBottomLeftRadius: '35px',
            backgroundImage: `url(/images/${course.image})`,
            backgroundPosition: 'center',
            backgroundSize: "cover",
            color: 'black',
        }}>
            <CardActionArea sx={{minHeight:'85px', backgroundColor: 'rgba(0,0,0,0.5)',}} onClick={handleClick}>
                <CardContent sx={{}}>
                    <Typography sx={{color:'#FFFFFF', fontWeight: 'bold',}}> 
                    {course.name}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    );
}